// ===== 2. NetworkStatus Component - NetworkStatus.jsx =====
import React from 'react';
import { Alert, Badge, Tooltip } from 'antd';
import { FaWifi, FaCheckCircle } from 'react-icons/fa';
import { useOnlineStatus } from '../../hooks/NetworkError';

// Simple Badge Version (for header/navbar)
export const NetworkStatusBadge = ({ className = '' }) => {
  const { isOnline, wasOffline } = useOnlineStatus();

  if (isOnline && !wasOffline) {
    return (
      <Tooltip title="Connected">
        <FaWifi className={`text-green-500 text-lg ${className}`} />
      </Tooltip>
    );
  }

  if (!isOnline) {
    return (
      <Tooltip title="No Internet Connection">
        <Badge dot color="red">
          <FaWifi className={`text-red-500 text-lg ${className}`} />
        </Badge>
      </Tooltip>
    );
  }

  // Just came back online
  return (
    <Tooltip title="Connection Restored">
      <Badge dot color="green">
        <FaCheckCircle className={`text-green-500 text-lg ${className}`} />
      </Badge>
    </Tooltip>
  );
};

// Full Alert Version (for page content)
export const NetworkStatusAlert = ({ 
  className = 'mb-4',
  showWhenOnline = false,
  closable = true 
}) => {
  const { isOnline, wasOffline } = useOnlineStatus();

  // Don't show anything if online and not previously offline
  if (isOnline && !wasOffline && !showWhenOnline) {
    return null;
  }

  if (!isOnline) {
    return (
      <Alert
        message="No Internet Connection"
        description="You're currently offline. Some features may not work properly."
        type="error"
        icon={<FaWifi />}
        showIcon
        className={className}
        closable={closable}
        banner
      />
    );
  }

  // Just came back online
  if (wasOffline) {
    return (
      <Alert
        message="Connection Restored"
        description="You're back online! All features are now available."
        type="success"
        icon={<FaCheckCircle />}
        showIcon
        className={className}
        closable={closable}
        banner
      />
    );
  }

  // Show online status if requested
  if (showWhenOnline) {
    return (
      <Alert
        message="Connected"
        description="You're online and all features are available."
        type="success"
        icon={<FaWifi />}
        showIcon
        className={className}
        closable={closable}
        banner
      />
    );
  }

  return null;
};
